import { render, staticRenderFns } from "./RulesStatusForm.vue?vue&type=template&id=937e6548"
import script from "./RulesStatusForm.vue?vue&type=script&lang=js"
export * from "./RulesStatusForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports